export function formatPrice(priceInCents, currencySymbol = '€') {
  return `${currencySymbol}${(priceInCents / 100).toFixed(2)}`;
}

export function formatLocalizedPrice(priceInCents, currencySymbol = '€', locale = 'de-DE') {
  return `${currencySymbol}${(priceInCents / 100).toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}
  `;
}
